import script from "./container.vue?vue&type=script&setup=true&lang=js"
export * from "./container.vue?vue&type=script&setup=true&lang=js"

import "./container.vue?vue&type=style&index=0&id=ef4ea60a&lang=less"

const __exports__ = script;

export default __exports__